import script from "./BenchmarkEditPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./BenchmarkEditPopup.vue?vue&type=script&setup=true&lang=js"

import "./BenchmarkEditPopup.vue?vue&type=style&index=0&id=2e74ab33&scoped=true&lang=css"

import exportComponent from "/Users/uguraslan/work/ljs/tools/strike/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e74ab33"]])

export default __exports__